import { setTranslations } from "store/reducers/app";
import { store } from "store/store";

const AppController = {};

AppController.getTranslations = async (langId) => {
  if (!langId) return {};
  try {
    const response = await fetch(`/translations/${langId}.json`);
    const translations = await response.json();
    store.dispatch(setTranslations(translations));
    return translations;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export default AppController;
